import { render, staticRenderFns } from "./TermsAndConditionsApp.vue?vue&type=template&id=4f3f3960&"
import script from "./TermsAndConditionsApp.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports